import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';
import { FileUpload } from 'primereact/fileupload';
import { InputText } from 'primereact/inputtext';
import { InputTextarea } from "primereact/inputtextarea";
import { ProgressBar } from 'primereact/progressbar';
import { Tag } from 'primereact/tag';
import { Tooltip } from 'primereact/tooltip';
import React, { useCallback, useEffect, useRef, useState } from "react";
import PhoneInput from 'react-phone-number-input';
import 'react-slideshow-image/dist/styles.css';
import { _endPoints, setcustomer } from '../Helper/links';
import pattern from '../Helper/pattern';
import API from '../Helper/server/API';
import { useCustomer } from './useCustomer';
import { Image } from 'primereact/image';
import { Skeleton } from 'primereact/skeleton';

function CustomerComponet(props) {

    const [loding_set, set_loding_set] = useState(false)
    //   const {showNotification } = Notifications();

    const {
        // eslint-disable-next-line no-unused-vars
        visitor_name, handel_visitor_name, national_number, handel_national_number, phone_number, handel_phone_number, whatsapp_number, handel_whatsapp_number, city, handel_city, note, handel_note, verification, set_verification, customer_clear
        // eslint-disable-next-line react-hooks/rules-of-hooks
    } = useCustomer();

    const [cities, set_cities] = useState([])
    const selected_city_Template = (option, props) => {
        if (city.name_city) {
            return (
                <div className="flex align-items-center" style={{ fontFamily: "Cairo" }}>
                    <div>{city.name_city}</div>
                </div>
            );
        }

        return <span>{props.placeholder}</span>;
    };

    const ccity_option_Template = (option) => {
        return (
            <div className="flex align-items-center">
                <div>{option.name_city}</div>
            </div>
        );
    };

    //____________________________________________________________________________________________
    const fileUploadRef = useRef([]);
    const onTemplateSelectFile = (e, item) => {
        item.file = e.files
    };

    const onTemplateRemoveFile = (item, callback) => {
        item.file = []
        callback();
    };

    const onTemplateClearFiles = (item) => {
        item.file = [];
    };
    const headerTemplateFile = (options, item, key) => {
        const { className, chooseButton, cancelButton } = options;

        let size = 0;
        if (item?.file?.length > 0 && item.file[0]?.size) {
            size = item.file[0].size;
        }

        // الحجم كنسبة (5MB)
        const value = (size / 5000000) * 100;

        // ref الخاص بالـ FileUpload الحالي
        const fileUpload = fileUploadRef.current[key];

        const formattedValue = fileUpload
            ? fileUpload.formatSize(size)
            : '0 B';

        return (
            <div
                className={className}
                style={{
                    backgroundColor: 'transparent',
                    display: 'flex',
                    alignItems: 'center'
                }}
            >
                <div className="row align-items-center gap-3 ml-auto pr-4">
                    <div>{chooseButton}</div>
                    <div className="pr-3">{cancelButton}</div>
                </div>

                <span dir="ltr">{formattedValue} / 5 MB</span>

                <ProgressBar
                    value={value}
                    showValue={false}
                    style={{ width: '20rem', height: '12px', margin: '1rem' }}
                />
            </div>
        );
    };


    const itemTemplateFile = (file, props) => {
        return (
            <div className="col-md-12">
                <div className='row'>
                    <div className='col-md-6'>
                        {
                            file.type === "application/pdf" ?
                                <i className='pi pi-file-pdf ' role="presentation" style={{ fontSize: '9rem' }} />
                                :

                                <Image src={file.objectURL} alt={file.name} width="250" preview />

                        }
                    </div>
                    <div className="col-md-3 mt-5 pt-5 " >
                        <small>{file.name}</small>
                        <br></br>
                        <Tag value={props.formatSize} severity="warning" className="px-3 py-2" />

                    </div>
                    <div className="col-md-3 mt-5 pt-5 " >
                        <Button type="button" icon="pi pi-times" className="p-button-outlined p-button-rounded p-button-danger" onClick={() => onTemplateRemoveFile(file, props.onRemove)} style={{ marginRight: "9rem" }} />

                    </div>


                    <hr></hr>
                </div>
            </div>
        );
    };

    const emptyTemplateFile = () => {
        return (
            <>
                <div className="flex align-items-center flex-column">
                    <i className="pi pi-image mt-3 p-5" style={{ fontSize: '5em', borderRadius: '50%', backgroundColor: 'var(--surface-b)', color: 'var(--surface-d)' }}></i>
                </div>
                <span style={{ fontSize: '1.2em', color: 'var(--text-color-secondary)', fontFamily: "Cairo" }} className="my-5">
                    اسحب وأفلِت الصورة هنا
                </span>
            </>
        );
    };
    const chooseOptionsFile = { icon: 'pi pi-fw pi-images', iconOnly: true, className: 'custom-choose-btn p-button-rounded p-button-outlined' };
    const cancelOptionsFile = { icon: 'pi pi-fw pi-times', iconOnly: true, className: 'custom-cancel-btn p-button-danger p-button-rounded p-button-outlined' };
    const clearAllIdentityDocuments = () => {
        // تفريغ FileUpload
        fileUploadRef.current.forEach(ref => {
            if (ref) ref.clear();
        });

        // تفريغ البيانات
        const cleared = identity_document.map(index => ({
            ...index,
            value_key: ''
        }));

        set_identity_document(cleared);
    };

    const SetNewCustomer = async () => {

        set_loding_set(true);
        var validtion = true
        //_______________________________________________________________________________________
        //                         Validtion
        if (!visitor_name || (pattern.name_ar.test(visitor_name) === false && pattern.name_en.test(visitor_name) === false) || visitor_name === "" || visitor_name.length > 200) {
            validtion = false
            document.getElementById("lvisitor_name").style.color = 'red';
        }
        if (!phone_number || pattern.phone_number.test(phone_number) === false || phone_number === "" || phone_number.toString().length !== 9) {
            validtion = false
            document.getElementById("lphone_number").style.color = 'red';
        }
        if (whatsapp_number !== null && whatsapp_number !== '' &&
            (pattern.number_whatsapp.test(whatsapp_number) === false || whatsapp_number.length < 7 || whatsapp_number.length > 15)
        ) {
            validtion = false
            document.getElementById("lwhatsapp_number").style.color = 'red';
        }
        else if (whatsapp_number !== null && whatsapp_number !== '' && whatsapp_number.slice(0, 4) === '+218' && whatsapp_number.toString().length !== 13) {
            validtion = false
            document.getElementById("lwhatsapp_number").style.color = 'red';
        }
        if (!city || !city.ID_city || pattern.number_int.test(city.ID_city) === false) {
            validtion = false
            document.getElementById("lcity").style.color = 'red';
        }
        if (national_number !== null && national_number !== '' && pattern.national_number.test(national_number) === false) {
            validtion = false
            document.getElementById("lnational_number").style.color = 'red';
        }
        if (note !== null && note !== '' &&
            (pattern.name_ar.test(note) === false && pattern.name_en.test(note) === false)
        ) {
            validtion = false
            document.getElementById("lnote").style.color = 'red';
        }
        if (!verification && verification !== 0 && verification !== 1 && verification !== false && verification !== true) {
            validtion = false
            document.getElementById("lverification").style.color = 'red';
        }
        if (!validtion) {
            props.toast.current.show({
                style: {
                    fontFamily: "Cairo",
                    fontSize: "1.1rem"
                },
                life: 3000,
                severity: 'error', summary: 'خطــاء', detail: "أرجــو إدخــال بيــانات العميــل"
            });
        }
        else {
            const data = new FormData();
            data.append('id_city', city.ID_city ? city.ID_city : null);
            data.append('national_number', national_number);
            data.append('visitor_name', visitor_name);
            data.append('phone_number', phone_number);
            data.append('whatsapp_number', whatsapp_number);
            data.append('note', note);
            data.append('verification', verification)
            var identity_document_customer = []
            identity_document.map(index => {
                if (index.value_key || index?.file?.length > 0) {
                    if (index?.file?.length > 0)
                        data.append('images[]', index?.file[0])
                    identity_document_customer.push(index)
                }
            })
            data.append('identity_document_customer', JSON.stringify(identity_document_customer))
            const response = await API.post(_endPoints.customers.insert, data)
            if (response?.success) {
                props.set_customer(response.customer)
                props.set_show_new_customer(false)
                props.toast.current.show({
                    style: {
                        fontSize: "1.2rem",
                        fontFamily: "Cairo"
                    },
                    life: 3000,
                    severity: 'success', summary: ' نجــاح ', detail: response?.msg
                });
                customer_clear()
                clearAllIdentityDocuments()
            }
            else if (response?.success === 0) {
                props.toast.current.show({
                    style: {
                        fontFamily: "Cairo",
                        fontSize: "1.2rem"
                    },
                    life: 3000,
                    severity: 'error', summary: 'خطــاء', detail: response?.msg
                });
                if (response?.error === "visitor_name")
                    document.getElementById("lvisitor_name").style.color = "red"
                else if (response?.error === "phone_number")
                    document.getElementById("lphone_number").style.color = "red"
            }
        }
        set_loding_set(false);
    }
    const [identity_document, set_identity_document] = useState([])
    const handel_identity_document_value_key = useCallback((e, item) => {
        set_identity_document(prevData =>
            prevData.map(index => {
                if (
                    index.ID_identity === item.ID_identity
                ) {
                    const regex = new RegExp('^' + index.pattern_kay + '$');
                    if (regex && regex.test(e.target.value)) {

                        document.getElementById(`lname_kay_${index.ID_identity}`).style.color = 'black'
                    }
                    else {
                        document.getElementById(`lname_kay_${index.ID_identity}`).style.color = 'red'
                    }
                    return { ...index, value_key: e.target.value };
                }
                else {
                    return index;
                }
            })
        );
    }, [set_identity_document]);
    const [loading_get_cities, set_loading_get_cities] = useState(false)
    const GetCities = async () => {
        set_loading_get_cities(true)
        const response = await API.get(`${_endPoints.customers.page}`)
        if (response?.success) {
            set_cities(response.data.cities)
            set_identity_document(response.data.identity_document)
        }
        set_loading_get_cities(false)
    }
    useEffect(() => {
        GetCities();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return (
        <div className="ibox">
            <div className="ibox-head">
                <cente>
                    <div className="ibox-title" dir="ltr">
                        عميل جديد

                    </div>
                </cente>
            </div>
            <div className='ibox-body'>
                <div className="row"  >
                    <div className="col-md-4 mb-4">
                        <label id="lvisitor_name"> الأسم بالكامل *
                            <i className="ti ti-user pr-1" ></i>
                        </label>
                        < label id="msg_customer" style={{ paddingRight: "50px" }}></label>
                        <InputText value={visitor_name}
                            maxLength={255} placeholder=" الاسم" className="col-md-12 " style={{ fontFamily: "Cairo" }} inputStyle={{ fontFamily: "Cairo" }} panelStyle={{ fontFamily: "Cairo", textAlign: "right" }}
                            virtualScrollerOptions={{ itemSize: 38 }} field="visitor_name" dropdown onChange={(e) => handel_visitor_name(e)} scrollHeight="400px" />
                    </div>

                    <div className="col-md-2  mb-4">
                        <label id="lphone_number"> رقم الهاتف *
                            <i className="fa fa-phone pr-1" ></i>
                        </label>
                        <div className="p-inputgroup flex-1">
                            <InputText value={phone_number} maxLength={9} placeholder="9x1234567" style={{ fontFamily: "Cairo", textAlign: "left" }}
                                onChange={(e) => handel_phone_number(e)} />
                            <span className="p-inputgroup-addon" dir='ltr' style={{ borderRight: "0 nane", borderLeft: "1px solid #ced4da" }}>+218</span>

                        </div>
                    </div>

                    <div className="col-md-3  mb-4">
                        <label id="lwhatsapp_number"> رقم واتس اب
                            <i className="fa fa-whatsapp pr-1" ></i>
                        </label>
                        <div className="input-group" dir="ltr">
                            <PhoneInput
                                country='LY'
                                showValue
                                // defaultCountry="LY"
                                placeholder="ادخل رقم واتس اب"
                                value={whatsapp_number} maxLength={15} name="whatsapp_number" id="whatsapp_number"
                                onChange={handel_whatsapp_number}
                                className="p-inputtext p-component p-autocomplete-input p-autocomplete-dd-input p-autocomplete-input p-autocomplete-dd-input col-md-12 pr-0"
                            />
                        </div>
                    </div>
                    <div className="col-md-3  mb-4">
                        <label id="lcity">عنوان الإقامة *
                            <i className="ti ti-map pr-1" ></i>
                        </label>
                        <div className="p-inputgroup flex-1">
                            <Dropdown value={city} onChange={(e) => handel_city(e)} options={cities} optionLabel="name_city" placeholder={<span style={{ fontFamily: "Cairo" }}>أختار المدينة</span>}
                                filter valueTemplate={selected_city_Template} itemTemplate={ccity_option_Template} className="w-full md:w-14rem"
                                emptyMessage="لم يتم العثور على نتائج" emptyFilterMessage="لم يتم العثور على نتائج" panelStyle={{ fontFamily: "Cairo" }} style={{ fontFamily: "Cairo" }} />
                        </div>
                    </div>

                    <div className="col-md-4  mb-4">
                        <label id="lnational_number">  رقم الوطني
                            <i className="ti ti-key pr-1" ></i>
                        </label>
                        < label id="msg_national_number" style={{ paddingRight: "50px" }}></label>
                        <InputText value={national_number}
                            maxLength={12} placeholder="x1990xxxxxxx" className="col-md-12 " style={{ fontFamily: "Cairo" }} inputStyle={{ fontFamily: "Cairo" }} panelStyle={{ fontFamily: "Cairo", textAlign: "right" }}
                            virtualScrollerOptions={{ itemSize: 38 }} field="national_number" dropdown onChange={(e) => handel_national_number(e)} scrollHeight="400px" />
                    </div>


                    <div className="col-md-8  mb-4" >
                        <label id="lnote"> ملاحظـــــة
                            <i className="ti ti-note pr-1" ></i>
                        </label>
                        <br></br>
                        <InputTextarea maxLength={1000} value={note} onChange={(e) => handel_note(e)} cols={200} />
                    </div>

                </div>
                <hr></hr>
                <div className="col-md-12  mb-4">
                    <label id="lverification" className='col-md-12'> التحـــقق مـن الهويـــة
                        <i className="ti ti-note pr-1" ></i>
                    </label>
                    <Button icon={verification ? "pi true-icon pi-check ml-2" : "pi false-icon pi-times ml-2"} label={verification ? "تــــم التحـــقق" : "لم يتـم التحــقق"} outlined severity={verification ? "success" : "danger"} size="large" className='mr-1'
                        onClick={(e) => {
                            document.getElementById('lverification').style.color = "black"
                            if (verification)
                                set_verification(0)
                            else
                                set_verification(1)
                            // document.getElementById("lstate").style.color = 'black';
                        }} />
                </div>
                {loading_get_cities ?
                    <Skeleton width="100%" height='35rem' ></Skeleton>
                    :
                    <>
                        <div class="clf">
                            <ul class="nav nav-tabs tabs-line nav-fill">
                                {identity_document.map((item, key) => {
                                    return <li class="nav-item">
                                        <a class={key == 0 ? "nav-link active" : "nav-link"} href={`#tab-${key}`} data-toggle="tab">
                                            <h6>  {item.name_identity}</h6>
                                        </a>
                                    </li>
                                })}
                            </ul>
                            <div class="tab-content mt-5">
                                {identity_document.map((item, key) => {
                                    return <div class={key == 0 ? "tab-pane show active" : "tab-pane"} id={`tab-${key}`}>
                                        <>
                                            <div className='col-md-12'>
                                                <div className="row">
                                                    <div className="col-md-4  mb-4">
                                                        {item.name_kay ?
                                                            <>
                                                                <label id={`lname_kay_${item.ID_identity}`}> {item.name_kay} *
                                                                    <i className="ti ti-key pr-1" ></i>
                                                                </label>
                                                                < label id={`msg_name_kay_${key}`} style={{ paddingRight: "50px" }}></label>
                                                                <InputText value={item.value_key}
                                                                    maxLength={10} placeholder={`ادخال ${item.name_kay}`} className="col-md-12 " style={{ fontFamily: "Cairo" }} inputStyle={{ fontFamily: "Cairo" }} panelStyle={{ fontFamily: "Cairo", textAlign: "right" }}
                                                                    virtualScrollerOptions={{ itemSize: 38 }} field={`name_kay_${key}`} dropdown
                                                                    onChange={(e) => handel_identity_document_value_key(e, item)} scrollHeight="400px" />
                                                            </>
                                                            : null
                                                        }
                                                    </div>

                                                    <div className="col-md-8 " >
                                                        <label id="lwhatsapp_number">وثيــقة {item.name_identity}
                                                            <i className="ti ti-file pr-1" ></i>
                                                        </label>
                                                        <Tooltip target=".custom-choose-btn" content="اختار" position="bottom" style={{ fontFamily: "Cairo" }} />
                                                        <Tooltip target=".custom-upload-btn" content="رفع" position="bottom" style={{ fontFamily: "Cairo" }} />
                                                        <Tooltip target=".custom-cancel-btn" content="تفريغ" position="bottom" style={{ fontFamily: "Cairo" }} />
                                                        <FileUpload ref={(el) => (fileUploadRef.current[key] = el)} name="demo[]" url="/api/upload" accept="image/jpeg,image/jpg,image/png" maxFileSize={5000000} multiple={false} id={`input_file_${item.ID_identity}`}
                                                            onSelect={(e) => onTemplateSelectFile(e, item)} onError={onTemplateClearFiles} onClear={() => onTemplateClearFiles(item)}
                                                            headerTemplate={(e) => headerTemplateFile(e, item, key)} itemTemplate={itemTemplateFile} emptyTemplate={emptyTemplateFile} style={{ textAlign: "center" }}
                                                            chooseOptions={chooseOptionsFile} cancelOptions={cancelOptionsFile} />
                                                    </div>
                                                </div>
                                            </div>
                                        </>
                                    </div>
                                })}
                            </div>
                        </div>
                        <div className="col-md-12" style={{ paddingTop: "40px" }}>
                            <center>
                                <Button label=" إضـــافة العميــــل " dir='rtl' raised className="pl-4 pr-4" style={{ fontFamily: "Cairo", margin: "1" }} onClick={SetNewCustomer} loading={loding_set} />
                            </center>
                        </div>
                    </>
                }



            </div>
        </div>
    )
}

export default CustomerComponet